var AbstractDialog = require("../common/AbstractDialog");
var PopupDialog = require("../common/PopupDialog");
var Utils = require("common/Utils");
var BrowserMutationObserver = MutationObserver || WebkitMutationObserver;

/**
 * @extends {AbstractDialog}
 * @class
 */
function AbstractAttributesDialog($htmlForm) {
    AbstractDialog.call(this);

    var self = this;
    var uiHelper = require("./AttributesUIHelper");

    var $form = $htmlForm;
    var $submitButton = $form.find("a.attribsDialogContinueBtn");
    var $attrList = $form.find("ul.attrList");

    var $content = self.getContent();
    $content.append($form);

    var submitChannel;
    var submitTopic;
    this.setSubmitEvent = function(channel, topic) {
        submitChannel = channel;
        submitTopic = topic;
    };

    // Fiddle fix to make sure pixel alignment is correct and dialog displays without
    // aliasing problems.
    var skipNext = false;
    var mutationObserver = new BrowserMutationObserver(function(mutations) {
        if (skipNext) {
            skipNext = false;
        } else {
            mutations.forEach(function(mutation) {
                var origleft = $(mutation.target).position().left;
                var rndleft = Math.round(origleft);

                if (rndleft !== origleft) {
                    skipNext = true;
                    $(mutation.target).css({left : rndleft});
                }
            });
        }
    });

    function buildAttributes($attrList, attributes, namespace) {
        for (var i = 0; i < attributes.length; i++) {
            var $fieldContainer = $("<li>", {"class" : "attrField", "data-namespace" : namespace});
            uiHelper.createAttributeUI(attributes[i], $fieldContainer, false, namespace);
            $attrList.append($fieldContainer);
        }
    }

    function prepareDialog(attributes, submitAttrs) {
        // Clear the current required attributes form
        $attrList.empty();

        // MFA we need to display the namespaces separately?
        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            var firstNamespace = true;
            Utils.iterateSorted(attributes, function(nsAtts, namespace) {
                // Construct new attribute fields
                var $newListItem = $("<li>", {"class" : "namespace", text : $.t("common::attributes.namespace." + namespace)});
                if (!firstNamespace) {
                    $newListItem.prepend($("<div>", {"class" : "namespaceDivider"}));
                } else {
                    firstNamespace = false;
                }
                $attrList.append($newListItem);
                buildAttributes($attrList, nsAtts, namespace);
            }, true);
        } else {
            buildAttributes($attrList, attributes["user"], "");
        }

        uiHelper.enhanceAttributesFormItems($attrList, submitAttrs);
        $attrList.listview("refresh");
    }

    this.promptForAttributes = function(attributes, launchId, launchCallback, title, allowSave) {
        var deferred = $.Deferred();

        if (attributes.user || attributes.session) {
            console.debug("submitting required launch attributes");

            var submitAttrs = function() {
                self.submitAttributes(launchId, deferred, launchCallback);
            };

            prepareDialog(attributes, submitAttrs);

            // What about session attributes that can't be saved?
            // Only show the save prompt if there are user attributes
            if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
                if (allowSave && (attributes["user"] === undefined || attributes["user"].length === 0)) {
                    allowSave = false;
                }
            }

            $submitButton.off("click.submitAttrs");
            $submitButton.on("click.submitAttrs", submitAttrs);

            // Register close handler to reject the deferred in the case that the user closed the popup
            $content.on("popupafterclose.rejectDeferred", function() {
                $content.off("popupafterclose.rejectDeferred");
                deferred.reject();
            });

            self.setTitle(title);
            $content.find("#saveAttrsDiv").toggle(allowSave);

            // Ensure the mutationObserver is watching the dialog
            $(".popupContainer").each(function() {
                mutationObserver.observe(this,
                    {attributes : true, childList : false, characterData : false, subtree : false});
            });

            PopupDialog.showPopup($content);
        } else {
            deferred.resolve();
        }

        return deferred.promise();
    };

    this.postDone = function(deferred, submitData) {
        console.debug("required attributes submitted OK");

        // Replace the close handler with one that will resolve the deferred
        $content.off("popupafterclose.rejectDeferred");
        $content.on("popupafterclose.handleDeferred", function() {
            $content.off("popupafterclose.handleDeferred");
            deferred.resolve(submitData);
        });
        $content.popup("close");
    };

    this.postFailed = function(errorsJson) {
        // Remove warning icons
        $form.find("li").removeClass("warningIcon");

        // Remove error messages
        $form.find("div.message").remove();

        // Insert error messages and highlight labels
        for (var i = 0; i < errorsJson.length; i++) {
            var $li = $form.find("input[name='" + errorsJson[i].field + "']").closest("li[data-namespace='" + (errorsJson[i].namespace || "") + "']");
            $li.addClass("warningIcon");
            var errMsg = errorsJson[i].errorMsg.trim();
            var i18nMsg = $.t("common::" + errMsg, {defaultValue : errMsg}); // Pre 7.0 the server responded with a non internationalized message
            $li.append($("<div>", {text : i18nMsg, "class" : "message"}));
        }
        $attrList.listview("refresh");
        $content.popup("reposition", {positionTo : "origin"});
    };

    this.submitAttributes = function(launchId, deferred, launchCallback) {
        var submitData = [];

        var $inputs = $form.find("input");

        for (i = 0; i < $inputs.length; i++) {
            var input = $inputs[i];
            var name = input.name;
            var value;

            if (input.type === "checkbox") {
                value = $(input).is(":checked");
            } else {
                value = $(input).val();
            }
            var namespace = $(input).closest("li").data("namespace");
            submitData.push({
                name : name,
                namespace : namespace || "",
                value : value
            });
        }

        // Set saveAttributes value to "yes" (only if it exists) as the API expects rather than the boolean value of the checkbox
        var doSave = false;

        for (var i = 0; i < submitData.length; i++) {
            if (submitData[i].name === "saveAttributes") {
                if (submitData[i].value === true) {
                    submitData[i].value = "yes";
                    doSave = true;
                } else {
                    submitData[i].value = "no";
                }
                break;
            }
        }

        self.publishEvent(submitChannel, submitTopic,
            {
                submitData : submitData,
                launchId : launchId,
                deferred : deferred,
                launchCallback : launchCallback,
                saveAttributes : doSave
            }
        );
    };

    this.resize = function(width, height) {
        var _height = height - $submitButton.outerHeight() - $(".resourcesHeader").outerHeight();
        $content.find(".scrollContent").css("max-height", _height);
    };
}

Utils.inherits(AbstractAttributesDialog, AbstractDialog);

module.exports = AbstractAttributesDialog;